export const SEARCH_VITALS = {
    QUERY_RESPONSE: 'search.query.response',
    RECOMMENDED_READY: 'search.recommended_ready'
} as const;

export type SearchVitalName = (typeof SEARCH_VITALS)[keyof typeof SEARCH_VITALS];

export const SEARCH_VITAL_DESCRIPTIONS: Record<SearchVitalName, string> = {
    [SEARCH_VITALS.QUERY_RESPONSE]: 'search_results',
    [SEARCH_VITALS.RECOMMENDED_READY]: 'search_recommended'
};
